import Logo from "../../../assets/logo";
import {
  IconType,
  JWayIcon,
  ProfilIcon,
} from "../../../common/assets/JWayIcons";
import Button from "../../../common/components/atom/Button/Button";
import BtnDrawerSelect from "../../../common/components/molecule/BtnDrawerSelect/BtnDrawerSelect";

import { useAuth } from "../../../features/auth/hooks";
import SingleOrganization from "../../../features/organization/components/SingleOrganization";
import { useSingleUser } from "../../../features/user/hooks/useAdminUser";
import { userRolesTraductor } from "../../../features/user/types/user.types";
import styles from "./Header.module.scss";
import useNavigationApp from "../../../navigation/useNavigationApp";
export default function Header() {
  const { userLogged, logOutUser, userRole } = useAuth();

  return (
    <div className={styles["header"]}>
      <div className={styles["header__logo"]}>
        <Logo to={"/"} />
      </div>
      <div className={styles["header__user"]}>
        <HeaderItem iconType={"admin"}>
          {userRolesTraductor(userRole)}
        </HeaderItem>
        <SelectOrgaBtn />
        <ProfilIcon size={15} color={"#CFD3D4"} />
        <span className={styles["header__user__name"]}>
          {userLogged?.user_firstname} {userLogged?.user_lastname}
        </span>
        <Button onClick={logOutUser}  bgColorHex="#7f010115" hoverColorHex="#7f010150"><span style={{
            color: "#7f0101",
            fontSize: "0.8rem",
            marginRight: "10px",
        }}>Déconnexion</span><JWayIcon type="exit" size={12} color='#7f0101' /> </Button>{" "}
      </div>
    </div>
  );
}

const HeaderItem = ({
  title,
  iconType,
  children,
  onClick,
}: {
  title?: string;
  children?: React.ReactNode;
  iconType?: IconType;
  onClick?: () => void;
}) => {
  return (
    <div
      className={[
        styles["header-item"],
        onClick ? styles["header-item--clickable"] : "",
      ].join(" ")}
      onClick={onClick}
    >
      {iconType && <JWayIcon type={iconType} size={14} color={"#CFD3D4"} />}
      <span className={[styles["header-item__title"], onClick ? styles["header-item__title--clickable"] : "",
      ].join(" ")}>{children}</span>
    </div>
  );
};

interface ItemBtnDrawer {
  textRender: () => JSX.Element;
  roleRender?: () => JSX.Element;
  onClick: () => void;
  isActive?: boolean;
}

const BtnDrawerSelectList = ({ content }: { content: ItemBtnDrawer[] }) => {
  return (
    <div className={[styles["btn-drawer-list"]].join(" ")}>
      {content.map((item, index) => {
        const isActive = item.isActive;

        return (
          <div
            key={index}
            className={[
              styles["item-btn-drawer"],
              isActive ? styles["item-btn-drawer--active"] : "",
            ].join(" ")}
            onClick={item.onClick}
          >
    
              <div className={[styles["item-btn-drawer__icon"], styles["icon"]].join(" ]")}>
                <JWayIcon type={"building"} size={16} color={"#CFD3D4"} />
              </div>
     
            <div className={[styles["item-btn-drawer__content"],styles["content"] ].join(" ")}>
            <div className={[styles["content__title-container"],styles["title-container"] ].join(" ")}>
          
              <span className={[styles["title-container__title"]].join(" ")}>
                {item.textRender()}
              </span>
            </div>
            <div className={[styles["content__desc-container"],styles["desc-container"] ].join(" ")}>
              <p className={[styles["desc-container__description"]].join(" ")}>{item.roleRender && item.roleRender()}</p>
            </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const SelectOrgaBtn = () => {
  const { userLogged, organizationIdUser, setUserOrgaLogged } = useAuth();
  const navigate = useNavigationApp();

  const { userOrgaListQuery } = useSingleUser(userLogged?.user_id);

  return (
    <BtnDrawerSelect
      minWidthModal={250}
      btnRender={({ onClick }) => (
        <>
          <HeaderItem iconType={"building"} onClick={onClick}>
            {organizationIdUser ? (
              <SingleOrganization.Name organizationId={organizationIdUser} />
            ) : (
              "Aucune"
            )}
          </HeaderItem>
        </>
      )}
      contentRender={({ closeModal }) => (
        <BtnDrawerSelectList
          content={
            userOrgaListQuery?.data?.data?.map((userOrga) => {
              return {
                isActive: userOrga.organization_id === organizationIdUser,

                textRender: () => {
                  return userOrga.organization_id === "" ? (
                    <></>
                  ) : (
                    <SingleOrganization.Name
                      organizationId={userOrga.organization_id}
                    />
                  );
                },

                roleRender: () => <>{userRolesTraductor(userOrga.user_orga_role)}</>,
                onClick: () => {
                  setUserOrgaLogged(userOrga);
                  closeModal();
                  navigate.goToHome();
                },
              };
            }) || []
          }
        />
      )}
    />
  );
};
